(function () {
  'use strict';

  var kit = document.querySelector('[data-bundle-kit]');
  if (!kit) return;

  var productMain = kit.closest('.product-main') || kit.closest('.shopify-section');
  var configKey = Object.keys(window.bundleKitConfig || {})[0];
  var config = (window.bundleKitConfig || {})[configKey];
  if (!config) return;

  var moneyFormat = config.moneyFormat || '${{amount}}';

  // --- Helpers ---

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function getSlots() {
    return kit.querySelectorAll('[data-bundle-slot]');
  }

  function getSelectedVariantId(slot) {
    // Fixed slot — no dropdown, variant is set in data attribute
    var fixedId = slot.dataset.fixedVariantId;
    if (fixedId) return Number(fixedId);

    var shade = slot.querySelector('[data-bundle-slot-shade]');
    if (shade && shade.value) return Number(shade.value);

    var color = slot.querySelector('[data-bundle-slot-color]');
    if (color && color.value) return Number(color.value);

    var hue = slot.querySelector('[data-bundle-slot-hue]');
    if (hue && hue.value) {
      // For hue-only (single variant products), the hue option stores product id
      // We need to get the first variant from the data attribute
      var selected = hue.options[hue.selectedIndex];
      if (selected) {
        var variants = parseVariants(selected);
        if (variants.length) return variants[0].id;
      }
    }

    return null;
  }

  function getSlotPrice(slot) {
    // Fixed slot — price stored in data attributes
    if (slot.dataset.fixedVariantId) {
      return {
        price: Number(slot.dataset.fixedPrice || 0),
        comparePrice: Number(slot.dataset.fixedComparePrice || 0)
      };
    }

    var shade = slot.querySelector('[data-bundle-slot-shade]');
    if (shade && shade.selectedIndex > 0) {
      var opt = shade.options[shade.selectedIndex];
      return {
        price: Number(opt.dataset.variantPrice || 0),
        comparePrice: Number(opt.dataset.variantComparePrice || 0)
      };
    }

    var color = slot.querySelector('[data-bundle-slot-color]');
    if (color && color.selectedIndex > 0) {
      var opt = color.options[color.selectedIndex];
      return {
        price: Number(opt.dataset.productPrice || 0),
        comparePrice: Number(opt.dataset.productComparePrice || 0)
      };
    }

    // For hue-only with single variant
    var hue = slot.querySelector('[data-bundle-slot-hue]');
    if (hue && hue.selectedIndex > 0) {
      var selected = hue.options[hue.selectedIndex];
      var variants = parseVariants(selected);
      if (variants.length) {
        return {
          price: variants[0].price,
          comparePrice: variants[0].compare_at_price || variants[0].price
        };
      }
    }

    return { price: 0, comparePrice: 0 };
  }

  function parseVariants(optionEl) {
    try {
      return JSON.parse(optionEl.dataset.productVariants || '[]');
    } catch (e) {
      return [];
    }
  }

  // --- Subtotal calculation ---

  function recalcSubtotal() {
    var subtotal = 0;
    var compareSubtotal = 0;

    if (!config.isYarnBundle) {
      subtotal += Number(config.mainPrice);
      compareSubtotal += Number(config.mainComparePrice);
    }

    getSlots().forEach(function (slot) {
      var qty = Number(slot.dataset.slotQuantity) || 1;
      var prices = getSlotPrice(slot);
      subtotal += prices.price * qty;
      compareSubtotal += prices.comparePrice * qty;
    });

    var subtotalEl = kit.querySelector('[data-bundle-subtotal-amount]');
    var compareEl = kit.querySelector('[data-bundle-compare-subtotal]');

    if (subtotalEl) subtotalEl.innerHTML = formatMoney(subtotal);
    if (compareEl) {
      compareEl.innerHTML = formatMoney(compareSubtotal);
      if (compareSubtotal > subtotal) {
        compareEl.classList.remove('hidden');
      } else {
        compareEl.classList.add('hidden');
      }
    }
  }

  // --- Swatch update ---

  function updateSwatch(slot, imageUrl) {
    var img = slot.querySelector('[data-bundle-slot-swatch-img]');
    if (img && imageUrl) img.src = imageUrl;
  }

  // Match variant options to product images (replicates old Vue getVariantImage)
  function getVariantImage(productImages, variantOptions) {
    if (!productImages || !productImages.length) return null;
    var match = null;
    variantOptions.forEach(function (optName) {
      if (!optName) return;
      var normalized = optName.split('(')[0].toLowerCase().replace(/\s+/g, '').trim();
      if (!normalized) return;
      var found = productImages.find(function (url) {
        return url.toLowerCase().includes(normalized);
      });
      if (found) match = found;
    });
    return match;
  }

  function getProductImages(hueOption) {
    try {
      return JSON.parse(hueOption.dataset.productImages || '[]');
    } catch (e) {
      return [];
    }
  }

  // Get the currently selected variant's options for image matching
  function getSelectedVariantOptions(slot) {
    var shadeSelect = slot.querySelector('[data-bundle-slot-shade]');
    if (!shadeSelect || shadeSelect.selectedIndex < 1) return [];
    var hueSelect = slot.querySelector('[data-bundle-slot-hue]');
    if (!hueSelect || hueSelect.selectedIndex < 1) return [];
    var hueOption = hueSelect.options[hueSelect.selectedIndex];
    var variants = parseVariants(hueOption);
    var selectedId = Number(shadeSelect.value);
    var variant = variants.find(function (v) { return v.id === selectedId; });
    if (!variant) return [];
    return [variant.option1, variant.option2].filter(Boolean);
  }

  // Update swatch based on selected shade variant
  function updateVariantSwatch(slot) {
    var hueSelect = slot.querySelector('[data-bundle-slot-hue]');
    if (!hueSelect || hueSelect.selectedIndex < 1) return;
    var hueOption = hueSelect.options[hueSelect.selectedIndex];
    var images = getProductImages(hueOption);
    var options = getSelectedVariantOptions(slot);
    var imageUrl = getVariantImage(images, options);
    if (!imageUrl) {
      // Fall back to featured image
      imageUrl = hueOption.dataset.productFeaturedImage;
    }
    if (imageUrl) updateSwatch(slot, imageUrl);
  }

  // --- Custom Swatch Dropdown ---

  function createSwatchDropdown(selectEl) {
    // Skip if already wrapped
    if (selectEl.classList.contains('swatch-dropdown-hidden')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'swatch-dropdown';

    // Add modifier class for simple color selects
    if (selectEl.matches('[data-bundle-slot-color]')) {
      wrapper.classList.add('swatch-dropdown--color');
    }

    // Build trigger button
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'swatch-dropdown__trigger';
    trigger.innerHTML =
      '<span class="swatch-dropdown__trigger-text">Select a color</span>' +
      '<svg class="swatch-dropdown__arrow" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" stroke="#080605" stroke-width="1.5" fill="none"/></svg>';

    // Build menu
    var menu = document.createElement('div');
    menu.className = 'swatch-dropdown__menu';

    buildMenuItems(selectEl, menu);

    // Set initial trigger state from current selection
    syncTrigger(selectEl, trigger);

    wrapper.appendChild(trigger);
    wrapper.appendChild(menu);

    // Insert after the select
    selectEl.parentNode.insertBefore(wrapper, selectEl.nextSibling);
    selectEl.classList.add('swatch-dropdown-hidden');

    // Toggle open/close
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = wrapper.classList.contains('swatch-dropdown--open');
      closeAllDropdowns();
      if (!isOpen) wrapper.classList.add('swatch-dropdown--open');
    });

    // Item click
    menu.addEventListener('click', function (e) {
      var item = e.target.closest('.swatch-dropdown__item');
      if (!item || item.classList.contains('swatch-dropdown__item--disabled')) return;

      var value = item.dataset.value;
      selectEl.value = value;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));

      // Update selected state
      menu.querySelectorAll('.swatch-dropdown__item').forEach(function (el) {
        el.classList.remove('swatch-dropdown__item--selected');
      });
      item.classList.add('swatch-dropdown__item--selected');

      syncTrigger(selectEl, trigger);
      wrapper.classList.remove('swatch-dropdown--open');
    });

    return wrapper;
  }

  function buildMenuItems(selectEl, menu) {
    menu.innerHTML = '';
    var isHue = selectEl.matches('[data-bundle-slot-hue]');
    var isShade = selectEl.matches('[data-bundle-slot-shade]');

    for (var i = 0; i < selectEl.options.length; i++) {
      var opt = selectEl.options[i];
      // Skip the placeholder "Select a ..." option
      if (opt.value === '' && opt.disabled) continue;

      var item = document.createElement('div');
      item.className = 'swatch-dropdown__item';
      item.dataset.value = opt.value;

      if (opt.selected && opt.value !== '') {
        item.classList.add('swatch-dropdown__item--selected');
      }
      if (opt.disabled) {
        item.classList.add('swatch-dropdown__item--disabled');
      }

      var imgSrc = getOptionSwatchUrl(opt, isHue, isShade);
      var imgClass = 'swatch-dropdown__item-img';
      if (!imgSrc) imgClass += ' swatch-dropdown__item-img--empty';

      item.innerHTML =
        '<img class="' + imgClass + '" src="' + (imgSrc || '') + '" alt="" loading="lazy">' +
        '<span class="swatch-dropdown__item-text">' + escapeHtml(opt.textContent.trim()) + '</span>';

      menu.appendChild(item);
    }
  }

  function getOptionSwatchUrl(opt, isHue, isShade) {
    // Simple color select: data-product-image
    if (!isHue && !isShade && opt.dataset.productImage && opt.dataset.productImage !== '') {
      return opt.dataset.productImage;
    }
    // Hue select: use first variant's shade image from product images
    if (isHue) {
      return getHueFirstVariantSwatch(opt);
    }
    // Shade select: try to derive from hue product images
    if (isShade) {
      return getShadeSwatchUrl(opt);
    }
    return '';
  }

  function getHueFirstVariantSwatch(hueOpt) {
    var images;
    try {
      images = JSON.parse(hueOpt.dataset.productImages || '[]');
    } catch (e) {
      images = [];
    }
    if (!images.length) return hueOpt.dataset.productFeaturedImage || '';

    var variants;
    try {
      variants = JSON.parse(hueOpt.dataset.productVariants || '[]');
    } catch (e) {
      variants = [];
    }

    // Get the first available variant's shade name
    var firstVariant = variants.find(function (v) { return v.available; }) || variants[0];
    if (!firstVariant) return hueOpt.dataset.productFeaturedImage || '';

    // The shade name is the option that isn't the size — try option2 first, then option1
    var shadeName = firstVariant.option2 || firstVariant.option1 || '';
    if (!shadeName) return hueOpt.dataset.productFeaturedImage || '';

    var normalized = shadeName.split('(')[0].toLowerCase().replace(/\s+/g, '').trim();
    if (!normalized) return hueOpt.dataset.productFeaturedImage || '';

    for (var i = 0; i < images.length; i++) {
      if (images[i].toLowerCase().includes(normalized)) {
        return images[i].replace(/(\.[a-z]+)(\?|$)/, '_100x100_crop_center$1$2');
      }
    }

    return hueOpt.dataset.productFeaturedImage || '';
  }

  function getShadeSwatchUrl(shadeOpt) {
    var shadeSelect = shadeOpt.parentElement;
    if (!shadeSelect) return '';
    var slot = shadeSelect.closest('[data-bundle-slot]');
    if (!slot) return '';
    var hueSelect = slot.querySelector('[data-bundle-slot-hue]');
    if (!hueSelect || hueSelect.selectedIndex < 1) return '';
    var hueOption = hueSelect.options[hueSelect.selectedIndex];
    var images = getProductImages(hueOption);
    if (!images.length) return '';

    // Match shade name to image filename
    var shadeName = shadeOpt.textContent.trim().replace(/ - Out of Stock$/, '');
    var normalized = shadeName.split('(')[0].toLowerCase().replace(/\s+/g, '').trim();
    if (!normalized) return '';

    for (var i = 0; i < images.length; i++) {
      if (images[i].toLowerCase().includes(normalized)) {
        // Return a sized version
        return images[i].replace(/(\.[a-z]+)(\?|$)/, '_100x100_crop_center$1$2');
      }
    }
    return '';
  }

  function syncTrigger(selectEl, trigger) {
    var triggerText = trigger.querySelector('.swatch-dropdown__trigger-text');
    if (selectEl.selectedIndex < 0 || selectEl.options[selectEl.selectedIndex].value === '') {
      triggerText.textContent = selectEl.options[0] ? selectEl.options[0].textContent.trim() : 'Select';
      return;
    }
    triggerText.textContent = selectEl.options[selectEl.selectedIndex].textContent.trim();
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function closeAllDropdowns() {
    kit.querySelectorAll('.swatch-dropdown--open').forEach(function (el) {
      el.classList.remove('swatch-dropdown--open');
    });
  }

  // Rebuild a swatch dropdown after the native select's options change (e.g. shade rebuild)
  function refreshSwatchDropdown(selectEl) {
    var wrapper = selectEl.nextElementSibling;
    if (!wrapper || !wrapper.classList.contains('swatch-dropdown')) {
      // If no wrapper yet, create one
      createSwatchDropdown(selectEl);
      return;
    }
    var menu = wrapper.querySelector('.swatch-dropdown__menu');
    var trigger = wrapper.querySelector('.swatch-dropdown__trigger');
    if (menu) buildMenuItems(selectEl, menu);
    if (trigger) syncTrigger(selectEl, trigger);
  }

  // Close dropdowns on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.swatch-dropdown')) {
      closeAllDropdowns();
    }
  });

  // Initialize all bundle selects as swatch dropdowns
  function initAllSwatchDropdowns() {
    kit.querySelectorAll('[data-bundle-slot-color], [data-bundle-slot-hue], [data-bundle-slot-shade]').forEach(function (sel) {
      createSwatchDropdown(sel);
    });
  }

  var addBtn = kit.querySelector('[data-bundle-add-to-cart]');

  // --- OOS state helper ---
  function updateSlotOosState(slot, isOos) {
    if (isOos) {
      slot.classList.add('bundle-slot--out-of-stock');
    } else {
      slot.classList.remove('bundle-slot--out-of-stock');
    }
  }

  // --- Color change (single-step) ---

  kit.addEventListener('change', function (e) {
    var target = e.target;

    if (target.matches('[data-bundle-slot-color]')) {
      var slot = target.closest('[data-bundle-slot]');
      var selected = target.options[target.selectedIndex];
      if (!selected) return;

      updateSwatch(slot, selected.dataset.productImage);

      // Sync swatch dropdown trigger
      var wrapper = target.nextElementSibling;
      if (wrapper && wrapper.classList.contains('swatch-dropdown')) {
        syncTrigger(target, wrapper.querySelector('.swatch-dropdown__trigger'));
      }

      var errorEl = kit.querySelector('[data-bundle-error]');
      if (errorEl) errorEl.classList.add('hidden');
      if (addBtn) addBtn.disabled = false;

      // Apply or remove OOS state based on selected option
      updateSlotOosState(slot, selected.disabled);

      recalcSubtotal();
    }

    // --- Hue change (two-step) ---
    if (target.matches('[data-bundle-slot-hue]')) {
      var slot = target.closest('[data-bundle-slot]');
      var selected = target.options[target.selectedIndex];
      if (!selected) return;

      // Rebuild shade dropdown
      var shadeSelect = slot.querySelector('[data-bundle-slot-shade]');
      if (shadeSelect) {
        var variants = parseVariants(selected);
        var slotSize = shadeSelect.dataset.slotSize || '';
        if (slotSize) {
          variants = variants.filter(function (v) {
            return (v.option1 && v.option1 === slotSize) || (v.option2 && v.option2 === slotSize);
          });
        }
        shadeSelect.innerHTML = '<option value="" disabled>Select a color</option>';
        variants.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = v.id;
          var shadeName = '';
          if (slotSize && v.option1 !== slotSize) shadeName = v.option1;
          if (slotSize && v.option2 !== slotSize && !shadeName) shadeName = v.option2;
          if (!shadeName) shadeName = v.option2 || v.option1;
          opt.textContent = shadeName + (v.available ? '' : ' - Out of Stock');
          opt.dataset.variantPrice = v.price;
          opt.dataset.variantComparePrice = v.compare_at_price || v.price;
          if (!v.available) opt.disabled = true;
          shadeSelect.appendChild(opt);
        });

        // Auto-select first available variant
        for (var i = 1; i < shadeSelect.options.length; i++) {
          if (!shadeSelect.options[i].disabled) {
            shadeSelect.selectedIndex = i;
            break;
          }
        }

        // Update swatch based on selected shade
        updateVariantSwatch(slot);

        // Refresh the shade swatch dropdown with new options
        refreshSwatchDropdown(shadeSelect);
      } else {
        // No shade dropdown — use product image
        var swatchUrl = selected.dataset.productImage || selected.dataset.productFeaturedImage;
        updateSwatch(slot, swatchUrl);
      }

      // Check if the selected hue itself is OOS
      updateSlotOosState(slot, selected.disabled);
      var errorEl = kit.querySelector('[data-bundle-error]');
      if (errorEl) errorEl.classList.add('hidden');
      if (addBtn) addBtn.disabled = false;

      // Sync hue swatch dropdown trigger
      var hueWrapper = target.nextElementSibling;
      if (hueWrapper && hueWrapper.classList.contains('swatch-dropdown')) {
        syncTrigger(target, hueWrapper.querySelector('.swatch-dropdown__trigger'));
      }

      recalcSubtotal();
    }

    // --- Shade change (two-step) ---
    if (target.matches('[data-bundle-slot-shade]')) {
      var slot = target.closest('[data-bundle-slot]');
      var shadeSelected = target.options[target.selectedIndex];
      updateVariantSwatch(slot);

      // Sync shade swatch dropdown trigger
      var shadeWrapper = target.nextElementSibling;
      if (shadeWrapper && shadeWrapper.classList.contains('swatch-dropdown')) {
        syncTrigger(target, shadeWrapper.querySelector('.swatch-dropdown__trigger'));
      }

      // Update OOS state based on selected shade
      updateSlotOosState(slot, shadeSelected && shadeSelected.disabled);

      recalcSubtotal();
    }

    // --- Bundle option toggle (Standard/Deluxe) ---
    if (target.matches('[data-bundle-option]')) {
      var quantities = target.value.split(',');
      getSlots().forEach(function (slot, i) {
        var qty = quantities[i] || 1;
        slot.dataset.slotQuantity = qty;
        var qtyInput = slot.querySelector('[data-bundle-slot-quantity]');
        if (qtyInput) qtyInput.value = qty;
      });
      recalcSubtotal();
    }
  });

  // --- Reset to original colors ---

  var resetBtn = kit.querySelector('[data-bundle-reset]');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      getSlots().forEach(function (slot) {
        // Single-step: reset color dropdown
        var colorSelect = slot.querySelector('[data-bundle-slot-color]');
        if (colorSelect) {
          for (var i = 0; i < colorSelect.options.length; i++) {
            if (colorSelect.options[i].hasAttribute('default-color')) {
              colorSelect.selectedIndex = i;
              var opt = colorSelect.options[i];
              updateSwatch(slot, opt.dataset.productImage);
              // Sync swatch dropdown
              var cWrapper = colorSelect.nextElementSibling;
              if (cWrapper && cWrapper.classList.contains('swatch-dropdown')) {
                syncTrigger(colorSelect, cWrapper.querySelector('.swatch-dropdown__trigger'));
                cWrapper.querySelectorAll('.swatch-dropdown__item').forEach(function (el) {
                  el.classList.remove('swatch-dropdown__item--selected');
                  if (el.dataset.value === opt.value) el.classList.add('swatch-dropdown__item--selected');
                });
              }
              updateSlotOosState(slot, opt.disabled);
              break;
            }
          }
        }

        // Two-step: reset hue dropdown to original product
        var hueSelect = slot.querySelector('[data-bundle-slot-hue]');
        if (hueSelect) {
          var originalId = hueSelect.dataset.currentProductId;
          for (var i = 0; i < hueSelect.options.length; i++) {
            if (hueSelect.options[i].value === originalId) {
              hueSelect.selectedIndex = i;
              hueSelect.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      });

      recalcSubtotal();

      var errorEl = kit.querySelector('[data-bundle-error]');
      if (errorEl) errorEl.classList.add('hidden');
    });
  }

  // --- Add to cart ---

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var items = [];
      var valid = true;
      var errorMsg = '';

      var bundleProps = { _bundle: 'true', _bundle_product: config.productId.toString() };
      if (config.productTitle) bundleProps._bundle_name = config.productTitle;
      if (config.productUrl) bundleProps._bundle_url = config.productUrl;

      // Add main product (pattern) if not yarn-only
      if (!config.isYarnBundle) {
        var mainInput = kit.querySelector('[data-bundle-main-product]');
        if (mainInput) {
          items.push({
            id: Number(mainInput.dataset.variantId),
            quantity: 1,
            properties: bundleProps
          });
        }
      }

      // Add each slot
      getSlots().forEach(function (slot) {
        var qty = Number(slot.dataset.slotQuantity) || 1;
        if (qty <= 0) return;

        var variantId = getSelectedVariantId(slot);
        if (!variantId) {
          valid = false;
          errorMsg = 'Please choose a color for all items.';
          return;
        }

        // Check if selected variant is out of stock
        var selectedOption = slot.querySelector('select option[value="' + variantId + '"]');
        if (selectedOption && selectedOption.disabled) {
          valid = false;
          errorMsg = 'One or more selected colors are out of stock. Please choose a different color.';
          return;
        }

        items.push({ id: variantId, quantity: qty, properties: bundleProps });
      });

      if (!valid) {
        var errorEl = kit.querySelector('[data-bundle-error]');
        if (errorEl) {
          errorEl.textContent = errorMsg;
          errorEl.classList.remove('hidden');
        }
        addBtn.disabled = true;
        return;
      }

      // Optimistic UI
      var btnText = kit.querySelector('[data-bundle-button-text]');
      var originalText = btnText ? btnText.textContent : '';
      addBtn.disabled = true;
      addBtn.classList.add('bundle-kit__add-to-cart--loading');
      if (btnText) btnText.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status && data.status >= 400) {
            var errorEl = kit.querySelector('[data-bundle-error]');
            if (errorEl) {
              errorEl.textContent = data.description || 'Could not add to cart.';
              errorEl.classList.remove('hidden');
            }
            addBtn.disabled = false;
            addBtn.classList.remove('bundle-kit__add-to-cart--loading');
            if (btnText) btnText.textContent = originalText;
          } else {
            if (btnText) btnText.textContent = 'Added!';
            // Open slide cart drawer
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (typeof window.refreshCart === 'function') {
                  window.refreshCart(cart);
                }
                document.querySelectorAll('.cart-container').forEach(function (c) {
                  c.classList.add('active');
                });
                document.body.classList.remove('overlay-removed');
                document.body.classList.add('locked');
              });
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.classList.remove('bundle-kit__add-to-cart--loading');
              if (btnText) btnText.textContent = originalText;
            }, 1500);
          }
        })
        .catch(function () {
          var errorEl = kit.querySelector('[data-bundle-error]');
          if (errorEl) {
            errorEl.textContent = 'Something went wrong. Please try again.';
            errorEl.classList.remove('hidden');
          }
          addBtn.disabled = false;
          addBtn.classList.remove('bundle-kit__add-to-cart--loading');
          if (btnText) btnText.textContent = originalText;
        });
    });
  }

  // --- Initialize swatch dropdowns on load ---
  initAllSwatchDropdowns();

  // --- Check initial OOS state for default-selected colors ---
  getSlots().forEach(function (slot) {
    var colorSelect = slot.querySelector('[data-bundle-slot-color]');
    var shadeSelect = slot.querySelector('[data-bundle-slot-shade]');
    var hueSelect = slot.querySelector('[data-bundle-slot-hue]');

    if (colorSelect && colorSelect.selectedIndex > 0) {
      var opt = colorSelect.options[colorSelect.selectedIndex];
      updateSlotOosState(slot, opt.disabled);
    } else if (shadeSelect && shadeSelect.selectedIndex > 0) {
      var opt = shadeSelect.options[shadeSelect.selectedIndex];
      updateSlotOosState(slot, opt.disabled);
    } else if (hueSelect && hueSelect.selectedIndex > 0) {
      var opt = hueSelect.options[hueSelect.selectedIndex];
      updateSlotOosState(slot, opt.disabled);
    }
  });
})();
